import { FC } from 'react';
import { AnalyticsDataClickArea } from 'src/types/googleAnalyticsEvents';
import { useTrackedClickHandler } from 'src/analytics/trackedClickHandler';
import { useEventClickSocial } from 'src/analytics/useEventClickSocial';
import { SvgHelperWrapper } from 'src/components';
import * as S from './styles';

export type SocialMediaType = 'facebook' | 'instagram' | 'twitter' | 'youtube';

export type SocialLinkConfig = {
  mediaType: SocialMediaType;
  SocialLogo: FC;
  ariaLabel: string;
  href: string;
};

export const SocialLink = ({
  link: { mediaType, ariaLabel, href, SocialLogo },
}: {
  link: SocialLinkConfig;
}) => {
  const eventClickSocial = useEventClickSocial(mediaType, AnalyticsDataClickArea.footer);
  const handleClick = useTrackedClickHandler(eventClickSocial);

  return (
    <S.SocialLink
      $mediaType={mediaType}
      aria-label={ariaLabel}
      data-testid="socialLink"
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      onClick={handleClick}
    >
      <SvgHelperWrapper Svg={SocialLogo} />
    </S.SocialLink>
  );
};
